import { render, staticRenderFns } from "./World.vue?vue&type=template&id=1b49eb37&scoped=true&"
import script from "./World.vue?vue&type=script&lang=js&"
export * from "./World.vue?vue&type=script&lang=js&"
import style0 from "./World.vue?vue&type=style&index=0&id=1b49eb37&prod&lang=css&"
import style1 from "./World.vue?vue&type=style&index=1&id=1b49eb37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b49eb37",
  null
  
)

export default component.exports